<template>
  <div class="cookies">
    <p>
      Diese Website verwendet Cookies – nähere Informationen dazu und zu Ihren
      Rechten als Benutzer finden Sie in unserer Datenschutzerklärung im
      Impressum. Klicken Sie auf „OK“, um Cookies zu akzeptieren und direkt
      unsere Website besuchen zu können.
    </p>
    <button @click="AcceptCookies">OK</button>
  </div>
</template>
<script>
export default {
  name: "Cookies",
  components: {},
  mounted() {
    //console.log(this.$route);
  },
  methods: {
    AcceptCookies() {
      this.$store.commit("AcceptCookies", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.cookies {
  position: fixed;
  width: 70%;
  height: auto;
  bottom: 0;
  padding: 1rem;
  z-index: 99;
  left: 15%;
  pointer-events: all;
  background-color: rgba($white,0.8);
  p {
    color: $black;
    margin-bottom: 0;
  }

  //text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000;
  border-radius: 6px 6px 0 0;
}

button {
  background-color: $blue;
  padding: 1rem;
  width: 100px;
  height: 50px;
  color: $white;
border-radius: 6px;
  margin-left: 1rem;
}


@include for-phone-only{
  .cookies {
    width:100%;
    left:0;
    background: #fff;
  }
}
</style>